
import { Injectable } from '@angular/core';

import { map, Observable, tap } from 'rxjs';
import { AuthService } from '@app/services/auth/auth.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
    console.log('auth guard');
  }

 canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean {
  if (!this.authService.isLoggedInObs()) {
    this.router.navigate(['unauthorized']);
    console.log('inte inloggad');
    return false;
  } else {
    console.log('inloggad...');
    return true;
  }
}
}

 


